import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    private http: HttpClient
  ) {
  }

  public getData(): Promise<any> {
    return this.http.get('https://jsonplaceholder.typicode.com/todos').toPromise();
  }

  public signIn(body = {}): Promise<any> {
    return this.http.post('https://jsonplaceholder.typicode.com/todos', body).toPromise();
  }
}
